// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { MdDelete, MdCloudUpload } from 'react-icons/md';
// import { summaryApi } from 'common';
// import uploadImage from 'helpers/uploadImage';

// const RepairRequestForm = () => {
//     const [formData, setFormData] = useState({
//         deviceType: '',
//         deviceBrand: '',
//         deviceModel: '',
//         issueDescription: '',
//         contactPhone: '',
//         contactEmail: '',
//         images: []
//     });

//     const [uploading, setUploading] = useState(false);
//     const [submitting, setSubmitting] = useState(false);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleImageUpload = async (e) => {
//         const files = Array.from(e.target.files);
        
//         // Check total images limit
//         if (formData.images.length + files.length > 4) {
//             toast.error('Maximum 4 images allowed');
//             return;
//         }

//         setUploading(true);

//         try {
//             const uploadPromises = files.map(file => uploadImage(file));
//             const uploadedImages = await Promise.all(uploadPromises);
            
//             const imageUrls = uploadedImages.map(img => img.secure_url);
            
//             setFormData(prev => ({
//                 ...prev,
//                 images: [...prev.images, ...imageUrls]
//             }));
            
//             toast.success('Images uploaded successfully');
//         } catch (error) {
//             console.error('Error uploading images:', error);
//             toast.error('Failed to upload images');
//         } finally {
//             setUploading(false);
//         }
//     };

//     const handleDeleteImage = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             images: prev.images.filter((_, i) => i !== index)
//         }));
//         toast.info('Image removed');
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         // Validation
//         if (!formData.deviceType || !formData.deviceBrand || !formData.deviceModel) {
//             toast.error('Please fill in all device details');
//             return;
//         }

//         if (!formData.issueDescription) {
//             toast.error('Please describe the issue');
//             return;
//         }

//         if (!formData.contactPhone || !formData.contactEmail) {
//             toast.error('Please provide contact information');
//             return;
//         }

//         if (formData.images.length === 0) {
//             toast.error('Please upload at least one image');
//             return;
//         }

//         setSubmitting(true);

//         try {
//             const response = await fetch(summaryApi.createRepairRequest.url, {
//                 method: summaryApi.createRepairRequest.method,
//                 credentials: 'include',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify(formData)
//             });

//             const data = await response.json();

//             if (data.success) {
//                 toast.success('Repair request submitted successfully!');
//                 // Reset form
//                 setFormData({
//                     deviceType: '',
//                     deviceBrand: '',
//                     deviceModel: '',
//                     issueDescription: '',
//                     contactPhone: '',
//                     contactEmail: '',
//                     images: []
//                 });
//             } else {
//                 toast.error(data.message || 'Failed to submit request');
//             }
//         } catch (error) {
//             console.error('Error submitting repair request:', error);
//             toast.error('Failed to submit request');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     return (
//         <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
//             <div className="mb-6">
//                 <h2 className="text-3xl font-bold text-gray-800">Submit Repair Request</h2>
//                 <p className="text-gray-600 mt-2">Fill in the details below and we'll get back to you soon</p>
//             </div>
            
//             <form onSubmit={handleSubmit} className="space-y-6">
//                 {/* Device Details Section */}
//                 <div className="bg-gray-50 p-6 rounded-lg">
//                     <h3 className="text-xl font-semibold text-gray-800 mb-4">Device Information</h3>
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Device Type *
//                             </label>
//                             <select
//                                 name="deviceType"
//                                 value={formData.deviceType}
//                                 onChange={handleChange}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 required
//                             >
//                                 <option value="">Select Type</option>
//                                 <option value="Phone">Phone</option>
//                                 <option value="Tablet">Tablet</option>
//                                 <option value="Laptop">Laptop</option>
//                                 <option value="Smartwatch">Smartwatch</option>
//                                 <option value="Gaming Console">Gaming Console</option>
//                                 <option value="Other">Other</option>
//                             </select>
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Brand *
//                             </label>
//                             <input
//                                 type="text"
//                                 name="deviceBrand"
//                                 value={formData.deviceBrand}
//                                 onChange={handleChange}
//                                 placeholder="e.g., Apple, Samsung, HP"
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 required
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Model *
//                             </label>
//                             <input
//                                 type="text"
//                                 name="deviceModel"
//                                 value={formData.deviceModel}
//                                 onChange={handleChange}
//                                 placeholder="e.g., iPhone 13 Pro, Galaxy S21"
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 required
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 {/* Issue Description */}
//                 <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Issue Description *
//                     </label>
//                     <textarea
//                         name="issueDescription"
//                         value={formData.issueDescription}
//                         onChange={handleChange}
//                         placeholder="Please describe what's wrong with your device in detail..."
//                         rows="6"
//                         className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         required
//                     />
//                     <p className="text-sm text-gray-500 mt-1">Be as specific as possible to help us diagnose the issue</p>
//                 </div>

//                 {/* Images Upload */}
//                 <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Device Images * (Upload 1-4 images)
//                     </label>
                    
//                     {formData.images.length < 4 && (
//                         <label className="cursor-pointer block">
//                             <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-500 hover:bg-blue-50 transition">
//                                 <MdCloudUpload className="mx-auto text-gray-400 mb-3" size={48} />
//                                 <p className="text-gray-600 font-medium mb-1">
//                                     {uploading ? 'Uploading images...' : 'Click to upload images'}
//                                 </p>
//                                 <p className="text-sm text-gray-500">
//                                     {formData.images.length}/4 images uploaded • PNG, JPG up to 10MB
//                                 </p>
//                             </div>
//                             <input
//                                 type="file"
//                                 multiple
//                                 accept="image/*"
//                                 onChange={handleImageUpload}
//                                 className="hidden"
//                                 disabled={uploading || formData.images.length >= 4}
//                             />
//                         </label>
//                     )}

//                     {/* Image Preview Grid */}
//                     {formData.images.length > 0 && (
//                         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
//                             {formData.images.map((image, index) => (
//                                 <div key={index} className="relative group">
//                                     <img
//                                         src={image}
//                                         alt={`Device ${index + 1}`}
//                                         className="w-full h-40 object-cover rounded-lg border-2 border-gray-300"
//                                     />
//                                     <button
//                                         type="button"
//                                         onClick={() => handleDeleteImage(index)}
//                                         className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
//                                         title="Remove image"
//                                     >
//                                         <MdDelete size={20} />
//                                     </button>
//                                     <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs">
//                                         Image {index + 1}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </div>

//                 {/* Contact Information */}
//                 <div className="bg-gray-50 p-6 rounded-lg">
//                     <h3 className="text-xl font-semibold text-gray-800 mb-4">Contact Information</h3>
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Contact Phone *
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="contactPhone"
//                                 value={formData.contactPhone}
//                                 onChange={handleChange}
//                                 placeholder="+234 XXX XXX XXXX"
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 required
//                             />
//                         </div>

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Contact Email *
//                             </label>
//                             <input
//                                 type="email"
//                                 name="contactEmail"
//                                 value={formData.contactEmail}
//                                 onChange={handleChange}
//                                 placeholder="your@email.com"
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 required
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 {/* Submit Button */}
//                 <button
//                     type="submit"
//                     disabled={submitting || uploading}
//                     className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition font-semibold text-lg shadow-md"
//                 >
//                     {submitting ? 'Submitting Request...' : 'Submit Repair Request'}
//                 </button>

//                 <p className="text-center text-sm text-gray-500">
//                     We'll review your request and get back to you within 24 hours
//                 </p>
//             </form>
//         </div>
//     );
// };

// export default RepairRequestForm;



import React, { useState } from 'react';
import uploadImage from 'helpers/uploadImage';
import { toast } from 'react-toastify';
import { MdDelete, MdCloudUpload } from 'react-icons/md';
import { useTheme } from "../../components/Theme/ThemeProvider";
import { summaryApi } from 'common';
import { authFetch } from '../../helpers/authFetch';

const RepairRequestForm = () => {
    const [formData, setFormData] = useState({
        deviceType: '',
        deviceBrand: '',
        deviceModel: '',
        issueDescription: '',
        contactPhone: '',
        contactEmail: '',
        images: []
    });

    const [uploading, setUploading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const { colors } = useTheme();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageUpload = async (e) => {
        const files = Array.from(e.target.files);
        
        if (formData.images.length + files.length > 4) {
            toast.error('Maximum 4 images allowed');
            return;
        }

        setUploading(true);

        try {
            const uploadPromises = files.map(file => uploadImage(file));
            const uploadedImages = await Promise.all(uploadPromises);
            
            const imageUrls = uploadedImages.map(img => img.secure_url);
            
            setFormData(prev => ({
                ...prev,
                images: [...prev.images, ...imageUrls]
            }));
            
            toast.success('Images uploaded successfully');
        } catch (error) {
            console.error('Error uploading images:', error);
            toast.error('Failed to upload images');
        } finally {
            setUploading(false);
        }
    };

    const handleDeleteImage = (index) => {
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }));
        toast.info('Image removed');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.deviceType || !formData.deviceBrand || !formData.deviceModel) {
            toast.error('Please fill in all device details');
            return;
        }

        if (!formData.issueDescription) {
            toast.error('Please describe the issue');
            return;
        }

        if (!formData.contactPhone || !formData.contactEmail) {
            toast.error('Please provide contact information');
            return;
        }

        if (formData.images.length === 0) {
            toast.error('Please upload at least one image');
            return;
        }

        setSubmitting(true);

        try {
            const response = await authFetch(summaryApi.createRepairRequest.url, {
                method: summaryApi.createRepairRequest.method,
                
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.success) {
                toast.success('Repair request submitted successfully!');
                setFormData({
                    deviceType: '',
                    deviceBrand: '',
                    deviceModel: '',
                    issueDescription: '',
                    contactPhone: '',
                    contactEmail: '',
                    images: []
                });
            } else {
                toast.error(data.message || 'Failed to submit request');
            }
        } catch (error) {
            console.error('Error submitting repair request:', error);
            toast.error('Failed to submit request');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div 
            className="max-w-4xl mx-auto p-6 rounded-lg shadow-md"
            style={{ backgroundColor: colors.bgSecondary }}
        >
            <div className="mb-6 mt-8">
                <h2 className="text-3xl font-bold" style={{ color: colors.text }}>
                    Submit Repair Request
                </h2>
                <p className="mt-2" style={{ color: colors.textSecondary }}>
                    Fill in the details below and we'll get back to you soon
                </p>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-6">
                {/* Device Details Section */}
                <div className="p-6 rounded-lg" style={{ backgroundColor: colors.bgTertiary }}>
                    <h3 className="text-xl font-semibold mb-4" style={{ color: colors.text }}>
                        Device Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                Device Type *
                            </label>
                            <select
                                name="deviceType"
                                value={formData.deviceType}
                                onChange={handleChange}
                                className="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                                style={{
                                    backgroundColor: colors.bgSecondary,
                                    color: colors.text,
                                    border: `1px solid ${colors.border}`,
                                    '--tw-ring-color': colors.primary
                                }}
                                required
                            >
                                <option value="">Select Type</option>
                                <option value="Phone">Phone</option>
                                <option value="Tablet">Tablet</option>
                                <option value="Laptop">Laptop</option>
                                <option value="Smartwatch">Smartwatch</option>
                                <option value="Gaming Console">Gaming Console</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                Brand *
                            </label>
                            <input
                                type="text"
                                name="deviceBrand"
                                value={formData.deviceBrand}
                                onChange={handleChange}
                                placeholder="e.g., Apple, Samsung, HP"
                                className="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                                style={{
                                    backgroundColor: colors.bgSecondary,
                                    color: colors.text,
                                    border: `1px solid ${colors.border}`,
                                    '--tw-ring-color': colors.primary
                                }}
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                Model *
                            </label>
                            <input
                                type="text"
                                name="deviceModel"
                                value={formData.deviceModel}
                                onChange={handleChange}
                                placeholder="e.g., iPhone 13 Pro, Galaxy S21"
                                className="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                                style={{
                                    backgroundColor: colors.bgSecondary,
                                    color: colors.text,
                                    border: `1px solid ${colors.border}`,
                                    '--tw-ring-color': colors.primary
                                }}
                                required
                            />
                        </div>
                    </div>
                </div>

                {/* Issue Description */}
                <div>
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                        Issue Description *
                    </label>
                    <textarea
                        name="issueDescription"
                        value={formData.issueDescription}
                        onChange={handleChange}
                        placeholder="Please describe what's wrong with your device in detail..."
                        rows="6"
                        className="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                        style={{
                            backgroundColor: colors.bgTertiary,
                            color: colors.text,
                            border: `1px solid ${colors.border}`,
                            '--tw-ring-color': colors.primary
                        }}
                        required
                    />
                    <p className="text-sm mt-1" style={{ color: colors.textSecondary }}>
                        Be as specific as possible to help us diagnose the issue
                    </p>
                </div>

                {/* Images Upload */}
                <div>
                    <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                        Device Images * (Upload 1-4 images)
                    </label>
                    
                    {formData.images.length < 4 && (
                        <label className="cursor-pointer block">
                            <div 
                                className="border-2 border-dashed rounded-lg p-8 text-center transition"
                                style={{ 
                                    borderColor: colors.border,
                                    backgroundColor: colors.bgTertiary
                                }}
                            >
                                <MdCloudUpload 
                                    className="mx-auto mb-3" 
                                    size={48}
                                    style={{ color: colors.textSecondary }}
                                />
                                <p className="font-medium mb-1" style={{ color: colors.text }}>
                                    {uploading ? 'Uploading images...' : 'Click to upload images'}
                                </p>
                                <p className="text-sm" style={{ color: colors.textSecondary }}>
                                    {formData.images.length}/4 images uploaded • PNG, JPG up to 10MB
                                </p>
                            </div>
                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={handleImageUpload}
                                className="hidden"
                                disabled={uploading || formData.images.length >= 4}
                            />
                        </label>
                    )}

                    {/* Image Preview Grid */}
                    {formData.images.length > 0 && (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                            {formData.images.map((image, index) => (
                                <div key={index} className="relative group">
                                    <img
                                        src={image}
                                        alt={`Device ${index + 1}`}
                                        className="w-full h-40 object-cover rounded-lg"
                                        style={{ border: `2px solid ${colors.border}` }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => handleDeleteImage(index)}
                                        className="absolute top-2 right-2 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg"
                                        style={{ backgroundColor: colors.error, color: '#ffffff' }}
                                        title="Remove image"
                                    >
                                        <MdDelete size={20} />
                                    </button>
                                    <div 
                                        className="absolute bottom-2 left-2 px-2 py-1 rounded text-xs"
                                        style={{ backgroundColor: 'rgba(0,0,0,0.6)', color: '#ffffff' }}
                                    >
                                        Image {index + 1}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Contact Information */}
                <div className="p-6 rounded-lg" style={{ backgroundColor: colors.bgTertiary }}>
                    <h3 className="text-xl font-semibold mb-4" style={{ color: colors.text }}>
                        Contact Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                Contact Phone *
                            </label>
                            <input
                                type="tel"
                                name="contactPhone"
                                value={formData.contactPhone}
                                onChange={handleChange}
                                placeholder="+234 XXX XXX XXXX"
                                className="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                                style={{
                                    backgroundColor: colors.bgSecondary,
                                    color: colors.text,
                                    border: `1px solid ${colors.border}`,
                                    '--tw-ring-color': colors.primary
                                }}
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-2" style={{ color: colors.text }}>
                                Contact Email *
                            </label>
                            <input
                                type="email"
                                name="contactEmail"
                                value={formData.contactEmail}
                                onChange={handleChange}
                                placeholder="your@email.com"
                                className="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2"
                                style={{
                                    backgroundColor: colors.bgSecondary,
                                    color: colors.text,
                                    border: `1px solid ${colors.border}`,
                                    '--tw-ring-color': colors.primary
                                }}
                                required
                            />
                        </div>
                    </div>
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    disabled={submitting || uploading}
                    className="w-full py-3 px-6 rounded-lg transition font-semibold text-lg shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                    style={{
                        backgroundColor: colors.primary,
                        color: '#ffffff'
                    }}
                >
                    {submitting ? 'Submitting Request...' : 'Submit Repair Request'}
                </button>

                <p className="text-center text-sm" style={{ color: colors.textSecondary }}>
                    We'll review your request and get back to you within 24 hours
                </p>
            </form>
        </div>
    );
};

export default RepairRequestForm;